module.exports = __webpack_public_path__ + "img/excel.642b78b6.svg";